module.exports = __webpack_public_path__ + "img/dairy_all-min.6b8e3582.png";